import PropTypes from 'prop-types';

const ValidationBullet = ({ condition, message }) => (
  <div className="validation-bullet w-100">
    <div className="circle">
      <div
        style={{ backgroundColor: !condition ? '#f15859' : '#46dd76' }}
      />
    </div>
    <p style={{ fontSize: 12, fontWeight: 600, marginBottom: 0 }}>{message}</p>
  </div>
);

ValidationBullet.propTypes = {
  condition: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default ValidationBullet;
